var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"report-view-card",attrs:{"to":_vm.link}},[_c('div',{staticClass:"report-crunch"},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('div',{staticClass:"report-title-sm"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }